export const solicitudMockData = {
  nombres: 'Juan Carlos',
  apellidos: 'Perez',
  calle: '9 de Julio',
  numeracion: '4752',
  municipalidad: 'Ciudad de Mendoza',
  provincia: 'Mendoza',
  documento: 12345678,
  fechaNacimiento: '12/31/1990',
  cuil: '20-12341234-5',
  cbu: '1234123412341234123412',
  telefono: '123456789',
};

export const createMockData = {
  error: false,
  codigo: 'PDF417_NO_ENCONTRADO',
  data: { id: '0f8fad5b-d9cb-469f-a165-70867728950e' },
};

export const createAsistidoMockData = {
  error: false,
  codigo: 'PDF417_NO_ENCONTRADO',
  data: { id: '0f8fad5b-d9cb-469f-a165-70867728950e' },
};

export const riesgoCrediticioMockData = {
  costoPaquete: 'Comisión Mensual: $5.000.-',
  detallePaquete:
    'PAQUETE ESMERALDA GOLD\nCaja de Ahorro\nCaja de Ahorros USD *\nCuenta Corriente con Acuerdo de $10.000\n1 chequera electrónica GRATIS\nCuenta Comitente\nPréstamo Personal (de contratación opcional)**\nTTCC GOLD con un límite de $200000.0\n\n* Contra certificación negativa de ANSES.\n** Sujeto a la Política de Crédito del Banco Coinag S.A. y condiciones de contratación.',
  paquete: 'PAQUETE ESMERALDA GOLD',
  productoTC: '2',
};

export const getValidateMockData = {
  id: 'f9346e7c-7fb2-4a51-4291-08dcc772d27b',
  entidadId: '5649588f-bc5b-4d1b-a392-ae8aa38487c9',
  aceptaTyC: null,
  cuil: '30708574836',
  documento: '708574836',
  nombres: 'pedro papa',
  email: 'cristian.g.fernandez@sandinas.com.ar',
  fechaNacimiento: '28/08/2024',
  apellidos: 'suarez',
  hora: '12:05',
  telefono: null,
  estado: 'Pendiente Representante Legal',
  tipoSociedad: 'altaSrlPj',
  razonSocial: 'Correo argentino',
  domicilio: [
    {
      id: '90043d88-c6ca-421c-8423-08dcc7730505',
      barrio: null,
      calle: 'BRANDSEN',
      codigoPostal: '1287',
      cpa: null,
      departamento: '',
      localidad: 'CAPITAL FEDERAL',
      manzana: null,
      numeracion: '2070',
      piso: '1',
      provincia: 'Capital Federal',
      pais: null,
      ciudad: null,
      municipalidad: null,
      tipoDomicilio: 'Fiscal',
    },
  ],
};
export const getSucursalesMockData = [
  {
    codPostal: 20000,
    calle: 'MITRE',
    nroCalle: 602,
    codigoPais: 80,
    codigoProvincia: 21,
    codigo: 1,
    descripcion: 'ROSARIO - CENTRO (PRD 24-07-2020)',
  },
  {
    codPostal: 21540,
    calle: 'AV SAN LORENZO',
    nroCalle: 701,
    codigoPais: 80,
    codigoProvincia: 21,
    codigo: 2,
    descripcion: 'CAPITAN BERMUDEZ (PRD 24-07-2020)',
  },
];

export const getProvinciasMockData = [
  {
    codigo: 1,
    descripcion: 'CAPITAL FEDERAL',
  },
  {
    codigo: 2,
    descripcion: 'BUENOS AIRES',
  },
  {
    codigo: 3,
    descripcion: 'CATAMARCA',
  },
  {
    codigo: 4,
    descripcion: 'CORDOBA',
  },
  {
    codigo: 5,
    descripcion: 'CORRIENTES',
  },
  {
    codigo: 6,
    descripcion: 'CHACO',
  },
  {
    codigo: 7,
    descripcion: 'CHUBUT',
  },
  {
    codigo: 8,
    descripcion: 'ENTRE RIOS',
  },
  {
    codigo: 9,
    descripcion: 'FORMOSA',
  },
  {
    codigo: 10,
    descripcion: 'JUJUY',
  },
  {
    codigo: 11,
    descripcion: 'LA PAMPA',
  },
  {
    codigo: 12,
    descripcion: 'LA RIOJA',
  },
  {
    codigo: 13,
    descripcion: 'MENDOZA',
  },
];

export const getLocalidadesMockData = [
  {
    codigo: 55000,
    descripcion: 'MENDOZA',
  },
  {
    codigo: 55010,
    descripcion: 'GODOY CRUZ',
  },
  {
    codigo: 55020,
    descripcion: 'ALAMEDA',
  },
];

export const getTipoSociedadMockData = [
  {
    codigo: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
    nombre: 'SOCIEDAD ANONIMA',
  },
  {
    codigo: '3fa64f64-5717-4562-b3fc-2c245f55afa2',
    nombre: 'UNION DE EMPRESAS',
  },
];

export const getTyCMockData = {
  nombre: 'tyc.pdf',
  contenido: '',
};

export const getPaqueteMockData = {
  costoPaquete: 'Comisión Mensual: $5.000.-',
  detallePaquete: [
    'PAQUETE ESMERALDA GOLD',
    'Caja de Ahorro',
    'Caja de Ahorros USD *',
    'Cuenta Corriente con Acuerdo de $10.000',
    '1 chequera electrónica GRATIS',
    'Cuenta Comitente',
    'Préstamo Personal (de contratación opcional)**',
    'TTCC GOLD con un límite de $200000.0',
    '* Contra certificación negativa de ANSES.',
    '** Sujeto a la Política de Crédito del Banco y condiciones de contratación.',
  ],
  paquete: 'PAQUETE ESMERALDA GOLD',
  productoTC: '2',
};

export const getDocumentacionTpoSociedadMockData = [
  {
    codigo: 'DOC001',
    nombre: 'Acta Constitutiva',
    file: null,
    nombreArchivo: null,
  },
  {
    codigo: 'DOC003',
    nombre: 'Acta Constitutiva',
    file: null,
    nombreArchivo: null,
  },
];

export const getCargosRepresentantesLegalesMockData = [
  {
    id: 1,
    cargo: 'Representante Legal',
  },
  {
    id: 2,
    cargo: 'Apoderado',
  },
];

// Vista previa de la empresa para la conformidad del representante legal (RF-ONB-19, AB#10741).
// El documento y el email llegan enmascarados desde el backend, no desde acá.
export const getVistaPreviaMockData = {
  id: '00000000-0000-0000-0000-000000000001',
  razonSocial: 'ACME S.A.',
  cuit: '30123456789',
  tipoSociedad: 'Sociedad Anónima',
  // Crudo a proposito: es como lo guarda hoy el flujo juridico, que no normaliza el telefono.
  telefono: '1123456789',
  conformidadRegistrada: false,
  // Dos domicilios a proposito: la pantalla de inicio del RL pinta una fila por domicilio
  // (AB#11306) y con uno solo ese caso no se puede ver en modo mock.
  domicilios: [
    {
      tipoDomicilio: 'Fiscal',
      calle: 'Av. Siempreviva',
      numeracion: '742',
      piso: '3',
      departamento: 'B',
      localidad: 'Rosario',
      provincia: 'Santa Fe',
      codigoPostal: '2000',
    },
    {
      tipoDomicilio: 'Comercial',
      calle: 'Mitre',
      numeracion: '1200',
      localidad: 'Rosario',
      provincia: 'Santa Fe',
      codigoPostal: '2000',
    },
  ],
  declaracionJurada: {
    esFacta: false,
    esOcde: true,
    esUif: false,
  },
  representantes: [
    {
      id: '00000000-0000-0000-0000-000000000011',
      cargo: 'Representante Legal',
      documentoEnmascarado: '*****456',
      emailEnmascarado: 'j***@acme.com',
    },
    {
      id: '00000000-0000-0000-0000-000000000012',
      cargo: 'Apoderado',
      documentoEnmascarado: '*****654',
      emailEnmascarado: 'm***@acme.com',
    },
  ],
};
